module.exports = __webpack_public_path__ + "img/YouLostMailScreenshot1_1920x1080.19ce968d.png";